import { HTMLAttributes, memo } from 'react';

import { cn } from '@growtherapy/sprout-ui';

import { useTheme } from '../hooks';
import { Theme } from '../state';
import { useContainerComponent } from '../video-sdk';

/**
 * The container for the center area in the waiting room and meeting rooms
 */
export const StageContainer = memo(function StageContainer({
  children,
  className,
  rounded,
  ...otherProps
}: {
  children: React.ReactNode;
  className?: string;
  rounded?: boolean;
} & HTMLAttributes<HTMLDivElement>) {
  const { theme } = useTheme();
  const VideoContainer = useContainerComponent();
  return (
    <VideoContainer
      styleOverride={{ display: 'flex' }}
      className={cn(
        {
          'sm:rounded-2xl border-neutral-800 border rebrand:border-border-state-selected-emphasis': rounded,
          'bg-neutral-300 rebrand:bg-surface-default': theme === Theme.LIGHT,
          'bg-neutral-800 rebrand:bg-surface-inverse': theme === Theme.DARK,
        },
        'overflow-hidden relative flex flex-col items-center flex-grow justify-center',
        className,
      )}
      {...otherProps}
    >
      {children}
    </VideoContainer>
  );
});
